<style lang="scss">
@import './custom-bootstrap.scss';
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

@import '~ion-rangeslider/css/ion.rangeSlider.min.css';

@import '~flag-icon-css/css/flag-icon.css';

@import './assets/font-awesome-5.15.3/css/all.css';

@import './assets/whhg-font/css/whhg.css';
@import '../node_modules/@mdi/font/css/materialdesignicons.min.css';

@import './assets/bitter-font/css/bitter.css';

@import './assets/roboto-mono-font/css/roboto-mono.css';

.card-header {
  font-size: 1.3em;
  text-align: center;
  font-weight: bold;
}

.disactivated_for_demo {
  visibility: hidden;
}

body {
  left: 0;
  margin: 0;
  position: relative;
  // font-family: 'Bitter', serif;
  transition: 0.3s;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

.caret {
  -webkit-transition: -webkit-transform 0.1s;
  -ms-transition: -ms-transform 0.1s;
  transition: transform 0.1s;
}

:not(.collapsed) > .caret {
  /* Safari */
  -webkit-transform: rotate(+90deg);

  /* Firefox */
  -moz-transform: rotate(+90deg);

  /* IE */
  -ms-transform: rotate(+90deg);

  /* Opera */
  -o-transform: rotate(+90deg);

  /* Internet Explorer */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.drag-area {
  min-height: 10px;
}

.hand-pointer:hover {
  cursor: grab;
}

.finger-pointer:hover {
  cursor: pointer;
}

.chosen_table_separator {
  margin-left: -20px;
  margin-right: -20px;
}

.sidemenu {
  height: 100%;
  width: 250px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: -250px;
  overflow-x: hidden;
  transition: 0.3s;
}

.app-navbar {
  -moz-box-shadow: 0 0 8px #000;
  -webkit-box-shadow: 0 0 8px #000;
  box-shadow: 0 0 8px #000;
  transition: all 0.3s ease;
}

.dropdown-toggle.no-caret:after {
  display: none;
}

.preserve_text_formatting {
  white-space: pre-wrap;
}

#synaplus_logo {
  transition: all 0.3s ease;
}

.synaplus-cosmo-scroll-container {
  display: block;
}

.synaplus-cosmo-add-scrollbar-x {
  overflow-x: scroll;
}

.synaplus-cosmo-add-scrollbar-y {
  overflow-y: scroll;
}

.synaplus-cosmo-no-scrollbar-x {
  overflow-x: hidden;
}

.synaplus-cosmo-no-scrollbar-y {
  overflow-y: hidden;
}

.synaplus-cosmo-scroll-containee {
  display: block;
  box-sizing: content-box;
}

.synaplus-cosmo-scroll-higher-720 {
  max-height: 720px;
  overflow-y: auto;
}

.synaplus-cosmo-h-120 {
  height: 120px;
}

.synaplus-cosmo-h-480 {
  height: 480px;
}

.synaplus-cosmo-h-720 {
  height: 720px;
}

.synaplus-cosmo-w-480 {
  width: 480px;
}

.synaplus-cosmo-spinpause {
  -webkit-animation: synaplus-cosmo-spinpause-animation 4s infinite ease;
}

@-webkit-keyframes synaplus-cosmo-spinpause-animation {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.synaplus-cosmo-json-highlight-string {
  color: $darkgreen;
}
.synaplus-cosmo-json-highlight-number {
  color: $darkorange;
}
.synaplus-cosmo-json-highlight-boolean {
  color: $darkblue;
}
.synaplus-cosmo-json-highlight-null {
  color: $darkpurple;
}
.synaplus-cosmo-json-highlight-key {
  color: $darkred;
}

.presymbol {
  position: relative;
  font-size: #{$presymbol-size}px;
  line-height: #{$presymbol-size}px;
  height: #{$presymbol-size}px;
  width: #{$presymbol-size}px;
  text-align: center;
}
.symbol {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: #{$symbol-size}px;
  line-height: #{$symbol-size}px;
  height: #{$symbol-size}px;
  width: #{$symbol-size}px;
  text-align: center;
  pointer-events: none;
}

.postsymbol {
  position: absolute;
  top: 40px;
  left: 20px;
  font-size: #{$postsymbol-size}px;
  line-height: #{$postsymbol-size}px;
  height: #{$postsymbol-size}px;
  width: #{$postsymbol-size}px;
  text-align: center;
}

.postsymboladdon {
  position: absolute;
  top: 85px;
  left: 20px;
  font-size: #{$postsymbol-size}px;
  line-height: #{$postsymbol-size}px;
  height: #{$postsymbol-size}px;
  width: #{$postsymbol-size}px;
  text-align: center;
}
.symbolholderdefault {
  position: absolute;
  top: #{$base-size - $dash-line-size}px;
  left: #{$base-size - $dash-line-size}px;
  // font-size: #{$presymbol-size}px;
  // line-height: #{$presymbol-size}px;
  height: #{$presymbol-size + 2 * $dash-line-size}px;
  width: #{$presymbol-size + 2 * $dash-line-size}px;
  text-align: center;
  padding: #{$dash-line-size}px;
  cursor: move;
  z-index: 1;
}

.active {
  background-color: $gray-300;
}

.tooltip-inner {
  text-align: left;
  max-width: 640px;
}

.tooltip {
  pointer-events: none;
}

.popover {
  pointer-events: none;
  text-align: left;
  max-width: 640px;
}

.license-field {
  font-style: italic;
  color: $gray-600;
}

@mixin color-border($color) {
  border-bottom: 0.25rem solid theme-color($color);
}

@each $color in 'primary', 'success', 'warning', 'danger' {
  .border-bottom-#{$color} {
    @include color-border($color);
  }
}

@mixin glow-variant($parent, $color) {
  #{$parent} {
    > .presymbol {
      display: inline-block;
      vertical-align: middle;
      -webkit-transform: perspective(1px) translateZ(0);
      transform: perspective(1px) translateZ(0);
      // box-shadow: 0 0 1px $color;
      text-shadow: 0 0 0px $color;
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-property: text-shadow;
      transition-property: text-shadow;
    }
    @include hover-focus-active {
      > .presymbol {
        text-shadow: 0 0 16px rgba($color, 0.6);
      }
    }
  }
}

@each $color, $value in $theme-colors {
  @include glow-variant('.synaplus-cosmo-glow-text-#{$color}', $value);
}
// *****************************************************************************

// Bootstrap complementary classes

.w-col-2 {
  width: 16.6667%;
}

.w-col-3 {
  width: 25%;
}

.min-w-0 {
  min-width: 0;
}

.min-h-0 {
  min-height: 0;
}

.flex-w-stretch {
  min-width: 0;
  flex-basis: 0 !important;
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.flex-h-stretch {
  min-height: 0;
  flex-basis: 0 !important;
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}
</style>

<style scoped lang="scss">
.fa-rotate-45 {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.small-padding {
  padding-top: 40px;
}
.large-padding {
  padding-top: 78px;
}
.criticalerror-enter-active,
.criticalerror-leave-active {
  transition: opacity 1s;
}
.criticalerror-enter,
.criticalerror-leave-to {
  opacity: 0;
}
</style>

<template>
  <fullscreen
    id="app"
    ref="fullscreen"
    :class="body_container_classes"
    tabindex="-1"
    @change="on_fullscreen_change"
    @keydown.native="quickcheck"
  >
    <b-modal
      ref="modalDisconnected"
      centered
      :title="$t('lost_connection')"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
    >
      <p class="my-4">{{ $t('waiting_for_connection') }}</p>
      <p class="my-4">{{ $t('thanks_understanding') }}</p>
    </b-modal>

    <b-modal
      id="license-modal"
      centered
      :title="$t('show_license')"
      ok-only
      :ok-title="$t('close')"
    >
      <div>
        {{ $t('company') }}:
        <span class="license-field">{{ license.client_name }}</span>
      </div>
      <div>
        {{ $t('start_validity') }}:
        <span class="license-field">{{ license_validity_start }}</span>
      </div>
      <div>
        {{ $t('stop_validity') }}:
        <span class="license-field">{{ license_validity_stop }}</span>
      </div>
    </b-modal>
    <project-snapshots :project_id="project_id" />

    <b-modal
      id="system-info-modal"
      centered
      scrollable
      size="xl"
      :title="$t('system_info')"
      ok-only
      :ok-title="$t('close')"
    >
      <!-- eslint-disable vue/no-v-html -->
      <pre v-html="system_info" />
      <pre v-html="aiplatform_config" />
      <!-- eslint-enable vue/no-v-html -->
    </b-modal>

    <!--     <navbar
      v-show="navbar_shown"
      ref="navbar"
      @toggle_fullscreen="toggle_fullscreen"
      @get_all_infos="get_all_infos"
    />

    <div v-show="navbar_shown" class="small-padding"></div>

    <transition name="component-fade" mode="out-in">
      <router-view :class="window_height" />
    </transition> -->

    <!--     <div class="d-flex flex-column">
      <navbar
        v-show="navbar_shown"
        ref="navbar"
        @toggle_fullscreen="toggle_fullscreen"
        @get_all_infos="get_all_infos"
      />

      <div class="vh-100">
        <div v-show="navbar_shown" class="small-padding"></div>

        <transition name="component-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div> -->
    <navbar
      v-show="navbar_shown"
      ref="navbar"
      @toggle_fullscreen="toggle_fullscreen"
      @get_all_infos="get_all_infos"
    />

    <transition name="component-fade" mode="out-in">
      <router-view />
    </transition>
  </fullscreen>
</template>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "start": "Start",
    "delete": "Delete",
    "validate": "Validate",
    "projects": "Projects",
    "cosmo_ai_platform": "Cosmo - Artificial Intelligence Platform",
    "waiting_for_connection": "You cannot use this application until the connection is restored",
    "thanks_understanding": "Thanks for your understanding",
    "lost_connection": "Connection lost",
    "pause_resume_project": "Pauses / resumes current project",
    "computing_project": "Current project is computing",
    "activated_idle_project": "Current project is activated but idle",
    "paused_project": "Current project is paused",
    "activates_deactivates_platform": "Powers on/off Cosmo",
    "computing_cosmo": "Cosmo is computing",
    "activated_idle_cosmo": "Cosmo is powered on but idle",
    "paused_cosmo": "Cosmo is paused",
    "duplicates_project": "Duplicate project",
    "project_administration": "Project Administration",
    "project_dashboard": "Project Dashboard",
    "show_warnings": "Show project warnings and errors",
    "erases_project": "Erase project",
    "export_project": "Export project",
    "import_project": "Import project",
    "hash_project": "Save project",
    "reboot_webserver": "Reboot webserver (aiplatform as well)",
    "fullscreen": "Fullscreen",
    "change_password": "Change password",
    "disconnect": "Disconnect",
    "show_license": "License",
    "company": "Company",
    "start_validity": "Validity start",
    "stop_validity": "Validity stop",
    "open": "Open",
    "close": "Close",
    "invalid_license": "License is invalid",
    "outofdate_license": "License is out of date",
    "insufficient_log_freespace": "Filesystem hosting logs has insufficient free space",
    "insufficient_data_freespace": "Filesystem hosting data has insufficient free space",
    "internal_memory_exceeded": "Internal platform memory usage exceeded",
    "external_memory_exceeded": "External platform memory usage exceeded",
    "table_creation_mode": "Created table's creation mode",
    "new_table_creation_mode": "Table that contains only new created columns",
    "stacked_creation_mode": "New columns added to the chosen table",
    "number": "Number",
    "string": "String",
    "table_preview": "Table preview",
    "json_preview": "Json preview",
    "system_info": "System information",
    "project_in_production": "Project in production",
    "platform_administration": "Platform Administration",
    "quicksave_successful": "Quicksave successful",
    "save_snapshot": "Save snapshot",
    "quickload_successful": "Quickload successful",
    "load_snapshot": "Load snapshot",
    "preferences": "Preferences"
  },
  "fr": {
    "cancel": "Annuler",
    "start": "Démarrer",
    "delete": "Supprimer",
    "validate": "Valider",
    "projects": "Projets",
    "cosmo_ai_platform": "Cosmo - Plateforme d'Intelligence Artificielle",
    "waiting_for_connection": "Tant que la connexion au serveur n'est pas revenue, il vous est impossible d'utiliser cette application",
    "thanks_understanding": "Merci de votre compréhension",
    "lost_connection": "La connexion au serveur a été interrompue",
    "pause_resume_project": "Met en pause / redémarre le projet actuel",
    "computing_project": "Le projet est en cours de calcul",
    "activated_idle_project": "Le projet est activé mais aucun calcul n'est programmé",
    "paused_project": "Le projet est en pause",
    "activates_deactivates_platform": "Active / désactive l'ensemble des calculs de Cosmo",
    "computing_cosmo": "Cosmo est en cours de calcul",
    "activated_idle_cosmo": "Cosmo est activé mais aucun calcul n'est programmé",
    "paused_cosmo": "Cosmo est en pause",
    "duplicates_project": "Dupliquer le projet",
    "project_administration": "Administration du projet",
    "project_dashboard": "Suivi du projet",
    "show_warnings": "Voir les avertissements et erreurs du projets",
    "erases_project": "Effacer le projet",
    "export_project": "Exporter le project",
    "import_project": "Importer un project",
    "hash_project": "Sauvegarder le projet",
    "reboot_webserver": "Relancer le serveur web (et donc la plateforme)",
    "fullscreen": "Plein écran",
    "change_password": "Changer le mot de passe",
    "disconnect": "Se déconnecter",
    "show_license": "Licence",
    "company": "Entreprise",
    "start_validity": "Début de validité",
    "stop_validity": "Fin de validité",
    "open": "Ouvrir",
    "close": "Fermer",
    "invalid_license": "License non valide",
    "outofdate_license": "License périmée",
    "insufficient_log_freespace": "Espace insuffisant dans le système de fichier hébergeant les fichiers de log",
    "insufficient_data_freespace": "Espace insuffisant dans le système de fichier hébergeant les fichiers de données",
    "internal_memory_exceeded": "Quota de mémoire interne utilisé par la plateforme dépassé",
    "external_memory_exceeded": "Quota de mémoire externe utilisé par la plateforme dépassé",
    "table_creation_mode": "Mode de création de la table de sortie",
    "new_table_creation_mode": "Table contenant uniquement les nouvelles colonnes",
    "stacked_creation_mode": "Nouvelles colonnes adjointes à la table d'entrée",
    "number": "Nombre",
    "string": "Chaîne de caractères",
    "table_preview": "Aperçu de la table",
    "json_preview": "Aperçu du Json",
    "system_info": "Informations système",
    "project_in_production": "Projet en production",
    "platform_administration": "Administration de la plateforme",
    "quicksave_successful": "Sauvegarde rapide réussie",
    "save_snapshot": "Sauvegarde d'une capture de workflow",
    "quickload_successful": "Chargement rapide réussi",
    "load_snapshot": "Chargement d'une capture de workflow",
    "preferences": "Préférences"
  }
}
</i18n>

<script>
import _ from 'lodash'
import velocity from 'velocity-animate'
import 'velocity-ui-pack'
import moment from 'moment'
import Chart from 'chart.js'

import { mapState, mapGetters } from 'vuex'

import {
  logout,
  delete_project,
  duplicate_project,
  get_system_info,
  get_aiplatform_config,
  save_project_snapshot,
  load_project_snapshot,
} from '@/api/subscriptions.js'

import chartColors from '@/components/chart_colors.js'

import { json_syntax_highlight } from '@/utils.js'

import { subscription_mixin } from '@/components/mixin.js'

import ProjectSnapshots from '@/components/project_snapshots.vue'

import Navbar from '@/components/navbar.vue'

// *****************************************************************************

export default {
  name: 'App',
  components: {
    ProjectSnapshots,
    Navbar,
  },
  mixins: [subscription_mixin],
  data() {
    return {
      menu_is_open: false,
      working_timer_id: undefined,
      license: '',
      system_info: '',
      aiplatform_config: '',
    }
  },
  metaInfo() {
    return {
      is_mounted: false,
      title: this.$t('projects'),
      titleTemplate: '%s | Cosmo | Synaplus',
      htmlAttrs: {
        lang: this.$root.$i18n.locale,
      },
      meta: [
        { author: 'Synaplus Solutions' },
        { description: this.$t('cosmo_ai_platform') },
        { keywords: `AI ML AutoML Data Wrangling` },
      ],
    }
  },
  computed: {
    navbar_shown() {
      return this.user_is_authenticated
    },

    body_container_classes() {
      return ['bg-white', 'd-flex', 'flex-column', 'min-vh-100']
    },

    // body_container_classes() {
    //   return ['bg-white', 'd-flex', 'flex-column']
    // },

    license_validity_start() {
      let start = ((this.license.validity_timespans || {})[0] || {})[0]
      return moment(start).format('DD/MM/YYYY')
    },
    license_validity_stop() {
      let start = ((this.license.validity_timespans || {})[0] || {})[1]
      return moment(start).format('DD/MM/YYYY')
    },

    project_id() {
      let project_id = -1
      let route = this.$route.path
      let regexp = new RegExp('/[^/]+/(\\d*)')
      let match = route.match(regexp)
      if (match) {
        project_id = parseInt(match[1], 10)
      }
      return project_id
    },
    running_bricks_uids() {
      let res = this.platform_status.current_running_brick_ids.toArray()
      // console.log("res :", res)
      return res
    },
    running_task_uid() {
      let res = this.platform_status.current_task_running
      return res
    },

    platform_running() {
      let res = this.platform_status.is_running
      return res
    },
    cannot_manipulate_platform() {
      // console.log(
      //   this.is_mounted,
      //   this.user_is_authenticated,
      //   !this.backend_connected
      // )
      // NOTE: the order of the test is important
      // Given that Vue determines implicit dependencies for a computed
      // from the accessed variables, it is important that all
      // variables are explored, otherwise a change in a later
      // variable will not be detected
      return (
        !this.backend_connected && this.user_is_authenticated && this.is_mounted
      )
    },
    ...mapState([
      'full_navbar_target',
      'authenticated_user_id',
      'backend_connected',
      'fullscreen_target',
    ]),
    ...mapGetters([
      'user_is_authenticated',
      // 'automl_bricks_undeleted_object_per_project',
    ]),
  },
  watch: {
    fullscreen_target(val) {
      this.$refs.fullscreen.toggle({ force: val })
    },
    cannot_manipulate_platform(nv, ov) {
      if (nv !== ov) {
        if (nv) {
          this.$refs.modalDisconnected.show()
        } else {
          this.$refs.modalDisconnected.hide()
        }
      }
    },
    user_is_authenticated(nv, ov) {
      if (nv !== ov) {
        if (nv) {
          this.fetch_collections(['globals', 'projects'])
        } else {
          this.unfetch_collections(['globals', 'projects'])
        }
      }
    },
  },
  beforeMount() {
    this.bound_on_navbar_transition_end = this.on_navbar_transition_end.bind(
      this
    )
    this.bound_on_before_print = this.on_before_print.bind(this)
  },
  async mounted() {
    this.is_mounted = true

    let fullscreen_status = await this.$refs.fullscreen.getState()
    this.$store.commit('set_fullscreen_status', fullscreen_status)

    // TODO : navbar ?
    let navbar = this.$refs.navbar
    navbar.$el.addEventListener(
      'transitionend',
      this.bound_on_navbar_transition_end
    )
    window.addEventListener('beforeprint', this.bound_on_before_print)
  },
  beforeDestroy() {
    if (!_.isUndefined(this.critical_error_handler)) {
      clearTimeout(this.critical_error_handler)
      this.critical_error_handler = undefined
    }

    window.removeEventListener('beforeprint', this.bound_on_before_print)

    let navbar = this.$refs.navbar
    navbar.$el.removeEventListener(
      'transitionend',
      this.bound_on_navbar_animation_end
    )
    this.is_mounted = false
  },
  methods: {
    async quickcheck(evt) {
      if (evt.key === 'F4') {
        await this.quicksave()
      } else if (evt.key === 'F9') {
        await this.quickload()
      }
    },
    async quicksave() {
      if (this.project_id !== -1) {
        await save_project_snapshot(this.project_id)
        this.$bvToast.toast(this.$t('quicksave_successful'), {
          title: this.$t('save_snapshot'),
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: false,
          variant: 'success',
        })
      }
    },
    async quickload(evt) {
      if (this.project_id !== -1) {
        await load_project_snapshot(this.project_id, 'latest')
        this.$bvToast.toast(this.$t('quickload_successful'), {
          title: this.$t('load_snapshot'),
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: false,
          variant: 'success',
        })
      }
    },
    on_navbar_transition_end() {
      this.$store.commit('set_full_navbar_status', this.full_navbar_target)
    },
    on_fullscreen_change(val) {
      this.$store.commit('set_fullscreen_status', val)
    },
    toggle_fullscreen() {
      this.$refs.fullscreen.toggle()
    },

    async duplicate_project() {
      let res = await duplicate_project(this.project_id, {
        uid: this.project_id,
      })
      this.$router.push(`/projects/${res.uid}/workflow`)
    },
    async get_system_info() {
      this.system_info = json_syntax_highlight(
        JSON.stringify(await get_system_info(), null, 2)
      )
    },
    async get_aiplatform_config() {
      this.aiplatform_config = json_syntax_highlight(
        JSON.stringify(await get_aiplatform_config(), null, 2)
      )
    },
    async get_all_infos() {
      await this.get_system_info()
      await this.get_aiplatform_config()
    },
    on_before_print() {
      for (let id in Chart.instances) {
        Chart.instances[id].resize()
      }
    },
  },
}
</script>

<!-- <style lang="scss">
@import './custom-bootstrap.scss';
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

@import '~ion-rangeslider/css/ion.rangeSlider.min.css';

@import '~flag-icon-css/css/flag-icon.css';

@import './assets/font-awesome-5.14.0/css/all.css';

@import './assets/whhg-font/css/whhg.css';
@import '../node_modules/@mdi/font/css/materialdesignicons.min.css';

@import './assets/bitter-font/css/bitter.css';

@import './assets/roboto-mono-font/css/roboto-mono.css';

.card-header {
  font-size: 1.3em;
  text-align: center;
  font-weight: bold;
}

.disactivated_for_demo {
  visibility: hidden;
}

body {
  left: 0;
  margin: 0;
  position: relative;
  // font-family: 'Bitter', serif;
  transition: 0.3s;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

.caret {
  -webkit-transition: -webkit-transform 0.1s;
  -ms-transition: -ms-transform 0.1s;
  transition: transform 0.1s;
}

:not(.collapsed) > .caret {
  /* Safari */
  -webkit-transform: rotate(+90deg);

  /* Firefox */
  -moz-transform: rotate(+90deg);

  /* IE */
  -ms-transform: rotate(+90deg);

  /* Opera */
  -o-transform: rotate(+90deg);

  /* Internet Explorer */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.drag-area {
  min-height: 10px;
}

.hand-pointer:hover {
  cursor: grab;
}

.finger-pointer:hover {
  cursor: pointer;
}

.chosen_table_separator {
  margin-left: -20px;
  margin-right: -20px;
}

.sidemenu {
  height: 100%;
  width: 250px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: -250px;
  overflow-x: hidden;
  transition: 0.3s;
}

.app-navbar {
  -moz-box-shadow: 0 0 8px #000;
  -webkit-box-shadow: 0 0 8px #000;
  box-shadow: 0 0 8px #000;
  transition: all 0.3s ease;
}

.dropdown-toggle.no-caret:after {
  display: none;
}

.preserve_text_formatting {
  white-space: pre-wrap;
}

#synaplus_logo {
  transition: all 0.3s ease;
}

.synaplus-cosmo-scroll-container {
  display: block;
}

.synaplus-cosmo-add-scrollbar-x {
  overflow-x: scroll;
}

.synaplus-cosmo-add-scrollbar-y {
  overflow-y: scroll;
}

.synaplus-cosmo-no-scrollbar-x {
  overflow-x: hidden;
}

.synaplus-cosmo-no-scrollbar-y {
  overflow-y: hidden;
}

.synaplus-cosmo-scroll-containee {
  display: block;
  box-sizing: content-box;
}

.synaplus-cosmo-scroll-higher-720 {
  max-height: 720px;
  overflow-y: auto;
}

.synaplus-cosmo-h-120 {
  height: 120px;
}

.synaplus-cosmo-h-480 {
  height: 480px;
}

.synaplus-cosmo-h-720 {
  height: 720px;
}

.synaplus-cosmo-spinpause {
  -webkit-animation: synaplus-cosmo-spinpause-animation 4s infinite ease;
}

@-webkit-keyframes synaplus-cosmo-spinpause-animation {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.synaplus-cosmo-json-highlight-string {
  color: $darkgreen;
}
.synaplus-cosmo-json-highlight-number {
  color: $darkorange;
}
.synaplus-cosmo-json-highlight-boolean {
  color: $darkblue;
}
.synaplus-cosmo-json-highlight-null {
  color: $darkpurple;
}
.synaplus-cosmo-json-highlight-key {
  color: $darkred;
}

.presymbol {
  position: relative;
  font-size: #{$presymbol-size}px;
  line-height: #{$presymbol-size}px;
  height: #{$presymbol-size}px;
  width: #{$presymbol-size}px;
  text-align: center;
}
.symbol {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: #{$symbol-size}px;
  line-height: #{$symbol-size}px;
  height: #{$symbol-size}px;
  width: #{$symbol-size}px;
  text-align: center;
  pointer-events: none;
}

.postsymbol {
  position: absolute;
  top: 40px;
  left: 20px;
  font-size: #{$postsymbol-size}px;
  line-height: #{$postsymbol-size}px;
  height: #{$postsymbol-size}px;
  width: #{$postsymbol-size}px;
  text-align: center;
}

.postsymboladdon {
  position: absolute;
  top: 85px;
  left: 20px;
  font-size: #{$postsymbol-size}px;
  line-height: #{$postsymbol-size}px;
  height: #{$postsymbol-size}px;
  width: #{$postsymbol-size}px;
  text-align: center;
}
.symbolholderdefault {
  position: absolute;
  top: #{$base-size - $dash-line-size}px;
  left: #{$base-size - $dash-line-size}px;
  // font-size: #{$presymbol-size}px;
  // line-height: #{$presymbol-size}px;
  height: #{$presymbol-size + 2 * $dash-line-size}px;
  width: #{$presymbol-size + 2 * $dash-line-size}px;
  text-align: center;
  padding: #{$dash-line-size}px;
  cursor: move;
  z-index: 1;
}

.active {
  background-color: $gray-300;
}

.tooltip-inner {
  text-align: left;
  max-width: 640px;
}

.tooltip {
  pointer-events: none;
}

.popover {
  pointer-events: none;
  text-align: left;
  max-width: 640px;
}

.license-field {
  font-style: italic;
  color: $gray-600;
}

@mixin color-border($color) {
  border-bottom: 0.25rem solid theme-color($color);
}

@each $color in 'primary', 'success', 'warning', 'danger' {
  .border-bottom-#{$color} {
    @include color-border($color);
  }
}

@mixin glow-variant($parent, $color) {
  #{$parent} {
    > .presymbol {
      display: inline-block;
      vertical-align: middle;
      -webkit-transform: perspective(1px) translateZ(0);
      transform: perspective(1px) translateZ(0);
      // box-shadow: 0 0 1px $color;
      text-shadow: 0 0 0px $color;
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-property: text-shadow;
      transition-property: text-shadow;
    }
    @include hover-focus-active {
      > .presymbol {
        text-shadow: 0 0 16px rgba($color, 0.6);
      }
    }
  }
}

@each $color, $value in $theme-colors {
  @include glow-variant('.synaplus-cosmo-glow-text-#{$color}', $value);
}
// *****************************************************************************

// Bootstrap complementary classes

.min-w-0 {
  min-width: 0;
}

.min-h-0 {
  min-height: 0;
}

.flex-w-stretch {
  min-width: 0;
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.flex-h-stretch {
  min-height: 0;
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}
</style>

<style scoped lang="scss">
.fa-rotate-45 {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.small-padding {
  padding-top: 40px;
}
.large-padding {
  padding-top: 78px;
}
.criticalerror-enter-active,
.criticalerror-leave-active {
  transition: opacity 1s;
}
.criticalerror-enter,
.criticalerror-leave-to {
  opacity: 0;
}
</style>

<template>
  <fullscreen
    id="app"
    ref="fullscreen"
    :class="body_container_classes"
    tabindex="-1"
    @change="on_fullscreen_change"
    @keydown.native="quickcheck"
  >
    <b-modal
      ref="modalDisconnected"
      centered
      :title="$t('lost_connection')"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
    >
      <p class="my-4">{{ $t('waiting_for_connection') }}</p>
      <p class="my-4">{{ $t('thanks_understanding') }}</p>
    </b-modal>

    <b-modal
      id="license-modal"
      centered
      :title="$t('show_license')"
      ok-only
      :ok-title="$t('close')"
    >
      <div>
        {{ $t('company') }}:
        <span class="license-field">{{ license.client_name }}</span>
      </div>
      <div>
        {{ $t('start_validity') }}:
        <span class="license-field">{{ license_validity_start }}</span>
      </div>
      <div>
        {{ $t('stop_validity') }}:
        <span class="license-field">{{ license_validity_stop }}</span>
      </div>
    </b-modal>
    <project-snapshots :project_id="project_id" />

    <b-modal
      id="system-info-modal"
      centered
      scrollable
      size="xl"
      :title="$t('system_info')"
      ok-only
      :ok-title="$t('close')"
    >
      <pre v-html="system_info" />
      <pre v-html="aiplatform_config" />
    </b-modal>
    <navbar
      v-show="navbar_shown"
      ref="navbar"
      @toggle_fullscreen="toggle_fullscreen"
      @get_all_infos="get_all_infos"
    />

    <div v-show="navbar_shown" class="small-padding"></div>

    <transition name="component-fade" mode="out-in">
      <router-view />
    </transition>
  </fullscreen>
</template>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "start": "Start",
    "delete": "Delete",
    "validate": "Validate",
    "projects": "Projects",
    "cosmo_ai_platform": "Cosmo - Artificial Intelligence Platform",
    "waiting_for_connection": "You cannot use this application until the connection is restored",
    "thanks_understanding": "Thanks for your understanding",
    "lost_connection": "Connection lost",
    "pause_resume_project": "Pauses / resumes current project",
    "computing_project": "Current project is computing",
    "activated_idle_project": "Current project is activated but idle",
    "paused_project": "Current project is paused",
    "activates_deactivates_platform": "Powers on/off Cosmo",
    "computing_cosmo": "Cosmo is computing",
    "activated_idle_cosmo": "Cosmo is powered on but idle",
    "paused_cosmo": "Cosmo is paused",
    "duplicates_project": "Duplicate project",
    "project_administration": "Project Administration",
    "show_warnings": "Show project warnings and errors",
    "erases_project": "Erase project",
    "export_project": "Export project",
    "import_project": "Import project",
    "hash_project": "Save project",
    "reboot_webserver": "Reboot webserver (aiplatform as well)",
    "fullscreen": "Fullscreen",
    "change_password": "Change password",
    "disconnect": "Disconnect",
    "show_license": "License",
    "company": "Company",
    "start_validity": "Validity start",
    "stop_validity": "Validity stop",
    "open": "Open",
    "close": "Close",
    "invalid_license": "License is invalid",
    "outofdate_license": "License is out of date",
    "insufficient_log_freespace": "Filesystem hosting logs has insufficient free space",
    "insufficient_data_freespace": "Filesystem hosting data has insufficient free space",
    "internal_memory_exceeded": "Internal platform memory usage exceeded",
    "external_memory_exceeded": "External platform memory usage exceeded",
    "table_creation_mode": "Created table's creation mode",
    "new_table_creation_mode": "Table that contains only new created columns",
    "stacked_creation_mode": "New columns added to the chosen table",
    "number": "Number",
    "string": "String",
    "table_preview": "Table preview",
    "system_info": "System information",
    "project_in_production": "Project in production",
    "platform_administration": "Platform Administration",
    "quicksave_successful": "Quicksave successful",
    "save_snapshot": "Save snapshot",
    "quickload_successful": "Quickload successful",
    "load_snapshot": "Load snapshot"
  },
  "fr": {
    "cancel": "Annuler",
    "start": "Démarrer",
    "delete": "Supprimer",
    "validate": "Valider",
    "projects": "Projets",
    "cosmo_ai_platform": "Cosmo - Plateforme d'Intelligence Artificielle",
    "waiting_for_connection": "Tant que la connexion au serveur n'est pas revenue, il vous est impossible d'utiliser cette application",
    "thanks_understanding": "Merci de votre compréhension",
    "lost_connection": "La connexion au serveur a été interrompue",
    "pause_resume_project": "Met en pause / redémarre le projet actuel",
    "computing_project": "Le projet est en cours de calcul",
    "activated_idle_project": "Le projet est activé mais aucun calcul n'est programmé",
    "paused_project": "Le projet est en pause",
    "activates_deactivates_platform": "Active / désactive l'ensemble des calculs de Cosmo",
    "computing_cosmo": "Cosmo est en cours de calcul",
    "activated_idle_cosmo": "Cosmo est activé mais aucun calcul n'est programmé",
    "paused_cosmo": "Cosmo est en pause",
    "duplicates_project": "Dupliquer le projet",
    "project_administration": "Administration du projet",
    "show_warnings": "Voir les avertissements et erreurs du projets",
    "erases_project": "Effacer le projet",
    "export_project": "Exporter le project",
    "import_project": "Importer un project",
    "hash_project": "Sauvegarder le projet",
    "reboot_webserver": "Relancer le serveur web (et donc la plateforme)",
    "fullscreen": "Plein écran",
    "change_password": "Changer le mot de passe",
    "disconnect": "Se déconnecter",
    "show_license": "Licence",
    "company": "Entreprise",
    "start_validity": "Début de validité",
    "stop_validity": "Fin de validité",
    "open": "Ouvrir",
    "close": "Fermer",
    "invalid_license": "License non valide",
    "outofdate_license": "License périmée",
    "insufficient_log_freespace": "Espace insuffisant dans le système de fichier hébergeant les fichiers de log",
    "insufficient_data_freespace": "Espace insuffisant dans le système de fichier hébergeant les fichiers de données",
    "internal_memory_exceeded": "Quota de mémoire interne utilisé par la plateforme dépassé",
    "external_memory_exceeded": "Quota de mémoire externe utilisé par la plateforme dépassé",
    "table_creation_mode": "Mode de création de la table de sortie",
    "new_table_creation_mode": "Table contenant uniquement les nouvelles colonnes",
    "stacked_creation_mode": "Nouvelles colonnes adjointes à la table d'entrée",
    "number": "Nombre",
    "string": "Chaîne de caractères",
    "table_preview": "Aperçu de la table",
    "system_info": "Informations système",
    "project_in_production": "Projet en production",
    "platform_administration": "Administration de la plateforme",
    "quicksave_successful": "Sauvegarde rapide réussie",
    "save_snapshot": "Sauvegarde d'une capture de workflow",
    "quickload_successful": "Chargement rapide réussi",
    "load_snapshot": "Chargement d'une capture de workflow"
  }
}
</i18n>

<script>
import _ from 'lodash'
import velocity from 'velocity-animate'
import 'velocity-ui-pack'
import moment from 'moment'
import Chart from 'chart.js'

import { mapState, mapGetters } from 'vuex'

import {
  logout,
  delete_project,
  duplicate_project,
  get_system_info,
  get_aiplatform_config,
  save_project_snapshot,
  load_project_snapshot,
} from '@/api/subscriptions.js'

import chartColors from '@/components/chart_colors.js'

import { json_syntax_highlight } from '@/utils.js'

import { subscription_mixin } from '@/components/mixin.js'

import ProjectSnapshots from '@/components/project_snapshots.vue'

import Navbar from '@/components/navbar.vue'

// *****************************************************************************

export default {
  name: 'App',
  components: {
    ProjectSnapshots,
    Navbar,
  },
  mixins: [subscription_mixin],
  data() {
    return {
      menu_is_open: false,
      working_timer_id: undefined,
      license: '',
      system_info: '',
      aiplatform_config: '',
    }
  },
  metaInfo() {
    return {
      is_mounted: false,
      title: this.$t('projects'),
      titleTemplate: '%s | Cosmo | Synaplus',
      htmlAttrs: {
        lang: this.$root.$i18n.locale,
      },
      meta: [
        { author: 'Synaplus Solutions' },
        { description: this.$t('cosmo_ai_platform') },
        { keywords: `AI ML AutoML Data Wrangling` },
      ],
    }
  },
  computed: {
    navbar_shown() {
      return this.user_is_authenticated
    },

    body_container_classes() {
      return ['bg-white', 'd-flex', 'flex-column', 'min-vh-100']
    },
    license_validity_start() {
      let start = ((this.license.validity_timespans || {})[0] || {})[0]
      return moment(start).format('DD/MM/YYYY')
    },
    license_validity_stop() {
      let start = ((this.license.validity_timespans || {})[0] || {})[1]
      return moment(start).format('DD/MM/YYYY')
    },

    project_id() {
      let project_id = -1
      let route = this.$route.path
      let regexp = new RegExp('/[^/]+/(\\d*)')
      let match = route.match(regexp)
      if (match) {
        project_id = parseInt(match[1], 10)
      }
      return project_id
    },
    running_bricks_uids() {
      let res = this.platform_status.current_running_brick_ids.toArray()
      // console.log("res :", res)
      return res
    },
    running_task_uid() {
      let res = this.platform_status.current_task_running
      return res
    },

    platform_running() {
      let res = this.platform_status.is_running
      return res
    },
    cannot_manipulate_platform() {
      // console.log(
      //   this.is_mounted,
      //   this.user_is_authenticated,
      //   !this.backend_connected
      // )
      // NOTE: the order of the test is important
      // Given that Vue determines implicit dependencies for a computed
      // from the accessed variables, it is important that all
      // variables are explored, otherwise a change in a later
      // variable will not be detected
      return (
        !this.backend_connected && this.user_is_authenticated && this.is_mounted
      )
    },
    ...mapState([
      'full_navbar_target',
      'authenticated_user_id',
      'backend_connected',
      'fullscreen_target',
    ]),
    ...mapGetters([
      'user_is_authenticated',
      // 'automl_bricks_undeleted_object_per_project',
    ]),
  },
  watch: {
    fullscreen_target(val) {
      this.$refs.fullscreen.toggle({ force: val })
    },
    cannot_manipulate_platform(nv, ov) {
      if (nv !== ov) {
        if (nv) {
          this.$refs.modalDisconnected.show()
        } else {
          this.$refs.modalDisconnected.hide()
        }
      }
    },
    user_is_authenticated(nv, ov) {
      if (nv !== ov) {
        if (nv) {
          this.fetch_collections(['globals', 'projects'])
        } else {
          this.unfetch_collections(['globals', 'projects'])
        }
      }
    },
  },
  beforeMount() {
    this.bound_on_navbar_transition_end = this.on_navbar_transition_end.bind(
      this
    )
    this.bound_on_before_print = this.on_before_print.bind(this)
  },
  async mounted() {
    this.is_mounted = true

    let fullscreen_status = await this.$refs.fullscreen.getState()
    this.$store.commit('set_fullscreen_status', fullscreen_status)

    // TODO : navbar ?
    let navbar = this.$refs.navbar
    navbar.$el.addEventListener(
      'transitionend',
      this.bound_on_navbar_transition_end
    )
    window.addEventListener('beforeprint', this.bound_on_before_print)
  },
  beforeDestroy() {
    if (!_.isUndefined(this.critical_error_handler)) {
      clearTimeout(this.critical_error_handler)
      this.critical_error_handler = undefined
    }

    window.removeEventListener('beforeprint', this.bound_on_before_print)

    let navbar = this.$refs.navbar
    navbar.$el.removeEventListener(
      'transitionend',
      this.bound_on_navbar_animation_end
    )
    this.is_mounted = false
  },
  methods: {
    async quickcheck(evt) {
      if (evt.key === 'F4') {
        await this.quicksave()
      } else if (evt.key === 'F9') {
        await this.quickload()
      }
    },
    async quicksave() {
      if (this.project_id !== -1) {
        await save_project_snapshot(this.project_id)
        this.$bvToast.toast(this.$t('quicksave_successful'), {
          title: this.$t('save_snapshot'),
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: false,
          variant: 'success',
        })
      }
    },
    async quickload(evt) {
      if (this.project_id !== -1) {
        await load_project_snapshot(this.project_id, 'latest')
        this.$bvToast.toast(this.$t('quickload_successful'), {
          title: this.$t('load_snapshot'),
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: false,
          variant: 'success',
        })
      }
    },
    on_navbar_transition_end() {
      this.$store.commit('set_full_navbar_status', this.full_navbar_target)
    },
    on_fullscreen_change(val) {
      this.$store.commit('set_fullscreen_status', val)
    },
    toggle_fullscreen() {
      this.$refs.fullscreen.toggle()
    },

    async duplicate_project() {
      let res = await duplicate_project(this.project_id, {
        uid: this.project_id,
      })
      this.$router.push(`/projects/${res.uid}/workflow`)
    },
    async get_system_info() {
      this.system_info = json_syntax_highlight(
        JSON.stringify(await get_system_info(), null, 2)
      )
    },
    async get_aiplatform_config() {
      this.aiplatform_config = json_syntax_highlight(
        JSON.stringify(await get_aiplatform_config(), null, 2)
      )
    },
    async get_all_infos() {
      await this.get_system_info()
      await this.get_aiplatform_config()
    },
    on_before_print() {
      for (let id in Chart.instances) {
        Chart.instances[id].resize()
      }
    },
  },
}
</script>
 -->
